import PrintBody from 'features/payment/pages/PrintPage/components/PrintBody';
import paymentSelectors from 'features/payment/services/selectors';
import { IBillDetailData } from 'features/payment/services/types/bill';
import { delay, sumBy } from 'lodash';
import React, { forwardRef, useImperativeHandle, useMemo, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import uuid from 'utils/uuid';
export type ReceiptStaffPrinterRef = {
  print: () => void;
};
const ReceiptStaffPrinter = forwardRef(({ }, ref) => {
  const printRef = useRef<HTMLDivElement>(null);
  const divStaffReceiptRef = useRef<HTMLDivElement>(null);
  const divRefs = useRef<HTMLDivElement[]>([]);
  const printIndex = useRef(0);
  const callbackResolve = useRef<((value: void) => void) | null>(null);
  const _data = paymentSelectors.getData();

  const billSplitByDataItems: IBillDetailData[] = useMemo(() => {
    const objectData = _data?.items.reduce((acc, item) => {
      const staffId = item.staffId;
      if (!acc[staffId]) {
        acc[staffId] = {
          ..._data,
          items: [],
          _localId: uuid(),
        };
      }
      const itemServices = item.services.map(o => ({
        ...o,
        price: (o.price || 0) - (o.supplyFee || 0),
      }));
      const itemResult = {
        ...item, services: itemServices,
      };
      acc[staffId].items.push(itemResult);

      const subTotal = sumBy(itemServices, 'price') || 0;
      const tip = item.tip || 0;
      const tipValue = tip > 0 ? tip - (item.tipFee || 0) : 0;
      acc[staffId].subTotal = subTotal;
      acc[staffId]._staffReceiptCustomData = {
        discount: item.discount || 0,
        tip: tipValue,
        total: subTotal + tipValue + (item.discount || 0),
      };
      return acc;
    }, {} as Record<string, IBillDetailData>);
    return Object.values(objectData || {});
  }, [_data]);

  const oPrintMultiple = useReactToPrint({
    content: () => divRefs.current[printIndex.current] || null,
    onAfterPrint: () => {
      if (printIndex.current < divRefs.current.length - 1) {
        printIndex.current++;
        delay(oPrintMultiple, 100);
      } else {
        // done
        callbackResolve.current?.();
      }
    },
  });

  const handlePrint = async () => {
    const receipts = (printRef.current?.querySelectorAll('.receipt-print') || []) as HTMLDivElement[];
    if (!receipts.length) return;
    printIndex.current = 0;
    divRefs.current = receipts;
    setTimeout(oPrintMultiple, 200);
    return new Promise((resolve) => {
      callbackResolve.current = resolve;
    });
  };

  useImperativeHandle(ref, () => ({
    print: () => handlePrint(),
  }));

  return (
    <>
      <div style={{ display: 'none' }} ref={printRef}>
        {billSplitByDataItems.map((item) => (
          <PrintBody key={item._localId} data={item} billRef={divStaffReceiptRef} isPrinter staffReceipt className='receipt-print' />
        ))}
      </div>
    </>
  );
});

ReceiptStaffPrinter.displayName = 'ReceiptStaffPrinter';

export default ReceiptStaffPrinter;
